import { Component, computed, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';

import { MdcDropdownComponent } from '../../../components/mdc/mdc-dropdown/mdc-dropdown.component';
import { LabelValue } from '../../../components/mdc/models/label-value.model';
import { UnavailabilityTypeEnum, UnavailabilityTypes } from '../../../consts/unavailability-types';
import { InfosGuidanceComponent } from '../../../components/infos-guidance/infos-guidance.component';
import { MdcDialogComponent } from '../../../components/mdc/mdc-dialog/mdc-dialog.component';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'set-repairer-status',
  imports: [ReactiveFormsModule, MatDialogModule, MdcDialogComponent, InfosGuidanceComponent, MdcDropdownComponent],
  template: `
    <mdc-dialog
      dialogTitle="Set Repairer Status"
      saveButtonText="APPLY"
      [closeOnSave]="false"
      [disableSave]="status.invalid"
      (save)="setStatus()">
      <ng-template #contentTemplate>
        <section class="flex flex-col items-center gap-y-20 pt-2 -mb-10">
          @if (status.value) {
            <infos-guidance [guidanceText]="guidance()" />
          }

          <mdc-dropdown
            class="w-full"
            label="Status"
            labelKey="label"
            [formControl]="status"
            [options]="statusOptions" />
        </section>
      </ng-template>
    </mdc-dialog>
  `
})
export class SetRepairerStatusComponent {
  #dialogRef = inject(MatDialogRef<SetRepairerStatusComponent>);
  #unavailabilityTypeEnum = UnavailabilityTypeEnum;
  companyName: string = inject(MAT_DIALOG_DATA);

  statusOptions: LabelValue<UnavailabilityTypes>[] = [
    { label: 'Active', value: undefined },
    { label: this.#unavailabilityTypeEnum.AT_CAPACITY, value: 'AT_CAPACITY' },
    { label: this.#unavailabilityTypeEnum.ABN_CHANGE, value: 'ABN_CHANGE' },
    { label: this.#unavailabilityTypeEnum.SHOP_CLOSURE, value: 'SHOP_CLOSURE' }
  ];

  status: FormControl = new FormControl(null, Validators.required);

  statusChange = toSignal(this.status.valueChanges);

  guidance = computed(() =>
    this.statusChange()?.value
      ? `${this.companyName} will no longer be able to receive new jobs. They can continue to action their existing jobs.`
      : `${this.companyName} will now be able to receive new jobs.`
  );

  setStatus(): void {
    const { value: unavailabilityType } = this.status.value;

    this.#dialogRef.close({ status: unavailabilityType ? 'UNAVAILABLE' : 'ACTIVE', unavailabilityType });
  }
}
